var $c3b6531c27488f67$exports = {};
$c3b6531c27488f67$exports = {
    "colorSwatchPicker": `V\xe4rimallit`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Valitse kohde`,
    "tableResizer": `Koon muuttaja`
};


export {$c3b6531c27488f67$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
